export default __webpack_public_path__ + "static/media/technology.f714aab1.svg";